<template>
  <span>
    <label class="a-form-label" for="businessCategory">{{ $t('label-edit-business-category') }}*</label>
    <select class="a-form-control" id="businessCategory" v-model="categoryBind" autocomplete="edit-business category-select">
      <option v-for="item in items" :key="item.value" :value="item.value" :disabled="item.isDisabled">{{ $t(item.text) }}</option>
    </select>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      items: [
        { value: 0, isDisabled: true, text: 'business-category-choose' },
        { value: 1, text: 'business-category-foodeat' },
        { value: 2, text: 'business-category-fooddrink' },
        { value: 3, text: 'business-category-foodothers' },
        { value: 4, text: 'business-category-productsclothes' },
        { value: 5, text: 'business-category-productsaccessories' },
        { value: 6, text: 'business-category-productsdecorations' },
        { value: 7, text: 'business-category-productsentertainment' },
        { value: 8, text: 'business-category-productsothers' },
        { value: 9, text: 'business-category-servicesentertainmentleisure' },
        { value: 10, text: 'business-category-servicesmaintenance' },
        { value: 11, text: 'business-category-servicescare' },
        { value: 12, text: 'business-category-servicesothers' },
        { value: 13, text: 'business-category-artsperformance' },
        { value: 14, text: 'business-category-artsartwork' },
        { value: 15, text: 'business-category-artsothers' }
      ]
    }
  },
  computed: {
    categoryBind: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
